import moment from 'moment';
import { memo, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import classNames from 'classnames/bind';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useSizes from '../../../../../hooks/sizes';
import Styles from './styles.module.scss';
import YearsFilterModal from './YearsFilterModal';

const cx = classNames.bind(Styles);

const YearsFilter = ({
  setStartEndYear, currentSelectedValue = '',
}) => {
  const { width } = useSizes();

  const generateYears = () => {
    const minYear = 2019;
    const currentYear = moment().year();
    const totalGap = currentYear - minYear;
    const years = [];
    for (let i = 0; i <= totalGap; i += 1) {
      years.push({
        id: `${currentYear - i}-uk-year-filter`,
        title: currentYear - i,
        value: currentYear - i,
      });
    }

    return years;
  };
  const [years, setYears] = useState([]);
  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState(Number(currentSelectedValue || currentYear));
  const [opened, setOpened] = useState(false);
  const [openedFilter, setOpenedFilter] = useState(false);

  useEffect(() => {
    if (!currentSelectedValue) return;
    setSelectedYear(Number(currentSelectedValue));
  }, [currentSelectedValue]);

  useEffect(() => {
    const years = generateYears();
    setYears(years);
  }, []);

  const toggleFilterModal = () => {
    setOpenedFilter(!openedFilter);
  };

  const handleCloseModal = () => {
    setOpenedFilter(false);
  };

  const toggleDropdow = () => {
    if (width <= 1024) {
      toggleFilterModal();
    } else {
      setOpened(!opened);
    }
  };

  const selectYearHandler = (selectedYear) => {
    const newYear = +selectedYear;
    setSelectedYear(newYear);
    setStartEndYear(selectedYear);
  };

  return (
    <Dropdown
      id={cx('years-filter')}
      className={cx('years_filter_dropdown')}
      show={opened}
      onToggle={toggleDropdow}
      onSelect={selectYearHandler}
    >
      <Dropdown.Toggle>
        <div className={cx('years_filter_title')}>
          {selectedYear}
          <div className={cx('years_filter_title_sub')}>Year</div>
        </div>
        <div className={cx('years_filter_icon')}>
          <FontAwesomeIcon icon={opened ? faChevronUp : faChevronDown} />
        </div>
      </Dropdown.Toggle>
      { width >= 1025 ? (
        <Dropdown.Menu
          flip={false}
          className={cx('years_filter_menu')}
        >
          <div className={cx('years_filter_menu_title')}>Year: </div>
          {
        years?.map((year) => (
          <Dropdown.Item
            key={year.id}
            eventKey={year.value}
            active={year.value === selectedYear}
          >
            {year.value}
          </Dropdown.Item>
        ))
      }
        </Dropdown.Menu>
      ) : (
        <YearsFilterModal openFilter={openedFilter} handleCloseModal={handleCloseModal}>
          <div className={cx('years_filter_menu_title')}>Year: </div>
          {
            years?.map((year) => (
              <Dropdown.Item
                key={year.id}
                eventKey={year.value}
                active={year.value === selectedYear}
              >
                {year.value}
              </Dropdown.Item>
            ))
          }
        </YearsFilterModal>
      )}
    </Dropdown>

  );
};

export default memo(YearsFilter);
